// extracted by mini-css-extract-plugin
export default {"loginModal":"loginModal_loginModal__Nxu5C","card":"loginModal_card__0lDlz","close":"loginModal_close__FdmQK"};